import React from "react";

// Inline SVG (not an <img>) so the wordmark can use the page's Inter font
// and stays crisp at any size.
const Logo = ({ className }) => (
    <svg className={className} viewBox="0 0 250 64" role="img" aria-label="Direct Signings Services" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 62C24 62 4 39 4 24a20 20 0 0 1 40 0c0 15-20 38-20 38z" fill="#0f1f3d" />
        <circle cx="24" cy="24" r="14" fill="#fff" />
        <path d="M34 13c-9 0-16 6-17.5 17 7-.5 15-6 17.5-17z" fill="#1d4ed8" />
        <path d="M14 34 29 18" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M14 34 17 30.5" stroke="#1d4ed8" strokeWidth="1.6" strokeLinecap="round" />
        <line x1="58" y1="14" x2="58" y2="50" stroke="#cbd5e1" strokeWidth="2" strokeLinecap="round" />
        <text x="70" y="32" fontFamily="Inter, sans-serif" fontSize="19" fontWeight="700" fill="#0f1f3d" letterSpacing="0.4">DIRECT SIGNINGS</text>
        <text x="71" y="49" fontFamily="Inter, sans-serif" fontSize="10.5" fontWeight="600" fill="#1d4ed8" letterSpacing="5.2">SERVICES</text>
    </svg>
);

export default Logo;
